// extracted by css-extract-rspack-plugin
export default {"cls1":"News-cls1_c-9","cls2":"News-cls2_g7R News-cls1_c-9"};